export function hasActivePaymentIntegration(list) {
  return list.some(
    (p) => p.service_name !== "manual_refunds" && !p.isRequestIntegration && !!p.is_connected
  )
}

export function getManual(list) {
  return list.find((p) => p.service_name === "manual_refunds")
}

export function shouldDisableManualButton(list) {
  const manual = getManual(list)
  if (!manual) return false

  const hasActive = hasActivePaymentIntegration(list)

  return manual.is_connected || hasActive
}
